import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import fetch from 'unfetch';
import qs from 'qs';
export default function getAvailability(url, data) {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  }; // ssm = showSafeMode - config from AO on whether to enable/disable certain endpoints (e.g. nationwide search)

  var query = qs.stringify(_objectSpread(_objectSpread({}, data), {}, {
    ssm: true
  })); // const query = qs.stringify({ ...data })

  return fetch("".concat(url, "?").concat(query), options).then(function (res) {
    return res.json();
  }).catch(function (error) {
    if (error.name === 'SyntaxError') {
      throw new Error('Syntax Error - No results found');
    }

    throw new Error("Error fetching availability from '".concat(url, "'.\n").concat(error));
  });
}